module.exports = __webpack_public_path__ + "img/tingchechang.2a093003.png";